<template >
  <!-- modal start-->
  <div v-if="modalOpen && modalOpen.config && modalOpen.config.display">

    <modal-window
        :title="modalOpen.title"
        :config="modalOpen.config"
    >
      <template #modal-content-slot>
        <!--
               <display-debug>
                 <template #debugView>modalOpen {{modalOpen}}</template>
               </disdebug>
       -->

        <component
            v-bind:is="'ContentIncludeView'"
            :router="modalOpen.router"
            :return-data="modalOpen.data"
            :form-prefill="modalOpen.prefill"
            :config="modalOpen.config"
        />

      </template>
    </modal-window>
  </div>
  <!-- modal end-->

  <div
      class="mapa"
      ref="mapWrrapper"
  >
    <ol-map
        ref="mapObj"
        :loadTilesWhileAnimating="true"
        :loadTilesWhileInteracting="true"
        :zoom="15"
        style="height: 100%;"
        @moveend="onMoveEnd"
    >
<!--  -->
      <ol-view
          ref="view"
          :center="fromLonLat(mapObj.center)"
          :zoom="mapObj.zoom"
      />
      <!-- Základní mapová vrstva -->
      <ol-tile-layer>

        <ol-source-xyz
            v-if="mapObj.mapBoxuUrl"
            :url="mapObj.mapBoxuUrl"
        />
        <ol-source-osm v-else />
      </ol-tile-layer>

      <!-- Clustering Layer -->
      <ol-vector-layer>
        <ol-source-cluster
            :distance="40"
        >
          <ol-source-vector>
            <ol-feature
                v-for="(marker, index) in mapVenues"
                :key="index"
                :properties="{ id: index, title: marker.title, data: marker, type: 'marker' }"
            >
              <ol-geom-point
                  :coordinates="fromLonLat([marker.lng, marker.lat])"
              ></ol-geom-point>
            </ol-feature>
          </ol-source-vector>
        </ol-source-cluster>



        <ol-style
            :overrideStyleFunction="overrideStyleFunction"
        >
          <ol-style-stroke color="red" :width="2"></ol-style-stroke>
          <ol-style-fill color="rgba(255,255,255,0.1)"></ol-style-fill>

          <ol-style-circle :radius="20">
            <ol-style-fill color="#3399CC"></ol-style-fill>
            <ol-style-stroke color="#fff" :width="1"></ol-style-stroke>
          </ol-style-circle>
          <ol-style-text>
            <ol-style-fill color="#fff"></ol-style-fill>
          </ol-style-text>
        </ol-style>
      </ol-vector-layer>

      <!-- selected venue -->
      <ol-vector-layer
        v-if="venue"
      >
        <ol-source-vector
            ref="markerSource"
            v-if="1==0"
        >
          <ol-feature

              :properties="{ type: 'detail' }"
          >
            <ol-geom-point
                :coordinates="fromLonLat([venue.lng, venue.lat])"
            ></ol-geom-point>
            <ol-style>
              <ol-style-icon
                  src="/img/map/geo-marker-azure.svg"
                  :scale="3"
                  :anchor="[0.5, 1]"
              ></ol-style-icon>
              <ol-style-text
                  :text="venue.title"
                  :offset="[0, -20]"
                  :font="'12px Calibri,sans-serif'"
                  :fill="{ color: '#000' }"
                  :stroke="{ color: '#fff', width: 3 }"
              ></ol-style-text>
            </ol-style>
          </ol-feature>
        </ol-source-vector>
      </ol-vector-layer>

      <!-- info box pro marker  -->
      <ol-overlay
          v-if="selectedMarker"
          :position="selectedMarker.position"
      >
        <div
            :class="'info-box'"
        >
          <h3>{{ selectedMarker.title }}</h3>
          <h6>{{ selectedMarker.data.address_title }}</h6>

          <div v-if="selectedMarker.data.subplace && selectedMarker.data.subplace.length > 0">
            <div
                v-for="(place) in selectedMarker.data.subplace"
                class="btn btn-sm btn-outline-primary me-1 mb-1"
                @click.prevent="setVenue(place.id)"
            >
              {{place.title}} [{{place.id}}]
            </div>
          </div>
          <template v-else>
            <div
                class="btn btn-sm btn-outline-primary me-1 mb-1"
                @click.prevent="setVenue(selectedMarker.id)"
            >
              Vybrat misto
            </div>
          </template>

          <div
              v-if="selectedMarker.data.events && selectedMarker.data.events.length > 0"
          >
            TODO EVENTS display
            <pre>{{ selectedMarker.data.events }}</pre>
          </div>


          <!--
          <p>{{ selectedMarker.title }}</p>
          <pre>{{ selectedMarker }}</pre>
          -->
          <button @click="closeOverlayWindow">Zavřít</button>
        </div>
      </ol-overlay>

    </ol-map>
  </div>




  <div class="d-flex">

    <div
        @click.prevent="openModalCreateNewVenue"
        class="btn btn-sm btn-outline-secondary d-block"
    >
      Vytvor nove misto
    </div>

  </div>





  <display-debug>
    <template #debugView>
      venue {{venue}}
    </template>
  </display-debug>

<!--

  <display-debug>
    <template #debugView>
      mapObj {{mapObj}}
    </template>
  </display-debug>

  <display-debug>
    <template #debugView>
      inputModel {{inputModel}}

    </template>
  </display-debug>

  <display-debug>
    <template #debugView>
      inputObj {{inputObj}}

    </template>
  </display-debug>
  -->

</template>

<script>
import ModalWindow from "@/components/content/ModalWindow.vue";

let timer;
import DisplayDebug from "@/components/general/DisplayDebug.vue";
import VueMultiselect from "vue-multiselect";
import {fromLonLat, toLonLat} from "ol/proj";
import { Feature, OSMSource } from 'ol';
import { Style, Icon, Circle as CircleStyle, Fill, Stroke, Text } from 'ol/style';
import { Collection } from 'ol'
import { Point, LineString, Circle } from 'ol/geom';
import { Vector as VectorSource, Cluster  } from 'ol/source';
import { Vector as VectorLayer } from 'ol/layer';
import { Modify } from 'ol/interaction'
import axios from "axios";
import ContentIncludeView from "@/views/ContentIncludeView.vue";

export default {
  name: "VenueInput",
  components: {
    ContentIncludeView,
    ModalWindow,
    DisplayDebug,
    VueMultiselect,
    Feature,
    OSMSource,
    fromLonLat,
    toLonLat,
    Modify,
    VectorLayer,
    VectorSource
},
  props: {
    "inputObj": Object,
    "formObj": Object,
    "modelValue": [String, Number, Object],
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      venue: null,
      mapVenues: null,
      selectedMarker: null,
      mapObj: {
        center: [14.4454686, 50.0693217],
        cursor: [14.4454686, 50.0693217],
        zoom: 13,
        mapBoxuUrl : this.getConfig('map.mapBoxStyleUrl'),
        markers: [],
      },


      inputModel: {},
      options: [],

      modalOpen: {
        title: null,
        router: {
          modul: null,
          action: null
        },
        config: {
          "display": false,
          "is_header": true,
          "is_close_btn": true,
          "is_footer": true
        },
        data: {
          save: false,
          submit: false,
        },
        callback: {},
        prefill: {},
      },
    }
  },
  created() {
    //console.clear();
  },
  mounted() {

    //console.log('dev event X', this.inputModel)
    /*
    if(this.inputModel) {
      this.creteateDetailData(this.inputModel);
    }else{
      //defaultni pozice
      const lastGPS = this.getGPS()
      if(lastGPS){
        this.mapObj.center= [lastGPS.lng, lastGPS.lat];
      }else{
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((position) => {
                //console.log('position', position.coords)
                this.mapObj.center = [position.coords.longitude, position.coords.latitude];
              },
              (error) => {
                console.log('position Err', error)
                this.mapObj.center = [this.getConfig('map.defaultPosition.lng'), this.getConfig('map.defaultPosition.lat')];
              }
          );
        }
      }
    }
*/
    const mapObj = this.$refs.mapObj
    if(mapObj){
      mapObj.map.on('click', (event) => {
        const feature = mapObj.map.forEachFeatureAtPixel(event.pixel, (feature) => feature)
        if (feature) {
          this.onClickFeature(feature.getProperties())
        }else{
          if(this.selectedMarker){
            this.selectedMarker = null;
          }
        }
      })
      mapObj.map.on('pointermove', this.handlePointerMove);
    }




  },
  methods: {
    fromLonLat,
    toLonLat,

    getVenueDetail(venueID){
      //console.log('dev getVenueDetail', venueID);
      //console.log('dev getVenueDetail', this.inputObj.action.path.detail + venueID);
      axios.defaults.baseURL = this.getBaseRoot();
      let apiPath = this.inputObj.action.path.detail + venueID
      axios({
        url: apiPath,
        method: 'get',
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        //console.log('dev getVenueDetail RES', res.data.response.detail);
        this.venue = res.data.response.detail;

        //nastavim mapu
        this.mapObj.center = [res.data.response.detail.lng, res.data.response.detail.lat];
        //this.mapObj.cursor = [res.data.response.detail.lng, res.data.response.detail.lat];

      })
      .catch((err) => {
        console.error("DEV creteateDetailData XXX", err);
        this.venue = null;
      })
      .finally(() => {
        //console.log("DEV tags finally");
      })

    },

    setVenue(id){
      this.formObj.general.inputs.venue_id.val = id;

      this.selectedMarker = null;

      const mapObj = this.$refs.mapObj
      this.loadVenuesInNeighborhood(mapObj.map)
    },

    closeOverlayWindow() {
        this.selectedMarker = null;
    },

    loadVenuesInNeighborhood(map){
      const view = map.getView()
      this.mapObj.zoom = view.getZoom()

      //this.center = view.getCenter();

      //hranice zobrazene mapy
      const extent = view.calculateExtent(map.getSize())
      const viewBoundariesRaw = {
        leftTop: toLonLat([extent[0].toFixed(6), extent[3]]),
        rightBottom: toLonLat([extent[2], extent[1]])
      }
      const viewBoundaries = {
        l: viewBoundariesRaw.leftTop[0],
        r: viewBoundariesRaw.rightBottom[0],
        t: viewBoundariesRaw.leftTop[1],
        b: viewBoundariesRaw.rightBottom[1]
      }
      //console.log('dev onMoveEnd viewBoundaries',viewBoundaries);

      let formData = new FormData();
      formData.append('bounds', JSON.stringify(viewBoundaries));
      formData.append('venue', JSON.stringify(this.venue));

      axios.defaults.baseURL = this.getBaseRoot();
      let apiPath = this.inputObj.action.path.mapMove
      axios({
        url: apiPath,
        method: 'post',
        data: formData,
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        //console.log('dev loadVenuesInNeighborhood RES', res.data.response.list);
        this.mapVenues = res.data.response.list
      })
      .catch((err) => {
        console.error("DEV loadVenuesInNeighborhood", err);
        this.venue = null;
      })
      .finally(() => {
        //console.log("DEV tags finally");
      })
    },

    onMoveEnd(event) {

      // event.target je instance OpenLayers Map
      if (event && event.target) {
        const map = event.target
        this.loadVenuesInNeighborhood(map)
        /*
        const view = map.getView()
        this.mapObj.zoom = view.getZoom()

        //this.center = view.getCenter();

        //hranice zobrazene mapy
        const extent = view.calculateExtent(map.getSize())
        const viewBoundariesRaw = {
          leftTop: toLonLat([extent[0].toFixed(6), extent[3]]),
          rightBottom: toLonLat([extent[2], extent[1]])
        }
        const viewBoundaries = {
          l: viewBoundariesRaw.leftTop[0],
          r: viewBoundariesRaw.rightBottom[0],
          t: viewBoundariesRaw.leftTop[1],
          b: viewBoundariesRaw.rightBottom[1]
        }
        console.log('dev onMoveEnd viewBoundaries',viewBoundaries);

        let formData = new FormData();
        formData.append('bounds', JSON.stringify(viewBoundaries));
        formData.append('venue', JSON.stringify(this.venue));

        axios.defaults.baseURL = this.getBaseRoot();
        let apiPath = this.inputObj.action.path.mapMove
        axios({
          url: apiPath,
          method: 'post',
          data: formData,
          withCredentials: true,
          headers: this.getRequestHeader(),
        }).then((res) => {
          console.log('dev onMoveEnd RES', res.data.response.list);
          this.mapVenues = res.data.response.list
        })
        .catch((err) => {
          console.error("DEV onMoveEnd", err);
          this.venue = null;
        })
        .finally(() => {
          //console.log("DEV tags finally");
        })
        */
        //console.log('dev getVenueDetail', this.inputObj.action.path.mapMove);
      }
    },

    overrideStyleFunction(feature, style, resolution){
      //console.log('overrideStyleFunction resolution', resolution);
      //console.log('overrideStyleFunction', feature, style, resolution );
      const clusteredFeatures = feature.get("features");
      const size = clusteredFeatures.length;

      //feature
      if(size > 1){
        feature.setProperties({
          "type": 'cluster'
        });
      }else{
        feature.setProperties(clusteredFeatures[0].getProperties());
      }

      if(size == 1 ){
        style = new Style({
          image: new Icon({
            anchor: [0.5, 1],
            scale: 2,
            src: '/img/map/geo-marker-red.svg',
          }),
        });
      }else{
        style = new Style({
          image: new CircleStyle({
            radius: 20,
            fill: new Fill({
              color: 'red'
            }),
            stroke: new Stroke({
              color: 'white' ,
              width: 1
            })
          }),
          text: new Text({
            text:  size,
            fill: new Fill({
              color: 'white'
            }),
            //font: breakPointToSet.text.font
          })
        });

        /*
        if(this.$config.cluster.breakpoints) {
          for (const breakpoint of this.$config.cluster.breakpoints) {
            const breakPointToSet = this.deepMergeItem(this.$config.cluster.defaultBreakpoint, breakpoint)

            if(size >= breakpoint.from  && size < breakpoint.to) {

              style = new Style({
                image: new CircleStyle({
                  radius: breakPointToSet.radius,
                  fill: new Fill({
                    color: breakPointToSet.fill.color
                  }),
                  stroke: new Stroke({
                    color: breakPointToSet.stroke.color ,
                    width: breakPointToSet.stroke.line
                  })
                }),
                text: new Text({
                  text:  size,
                  fill: new Fill({
                    color: breakPointToSet.text.color
                  }),
                  font: breakPointToSet.text.font
                })
              });

              if(typeof breakPointToSet.text.overide != "undefined"){
                style.getText().setText(breakPointToSet.text.overide);
              }
            }
          }
        }
        */
      }
      return style;
    },

    onClickFeature(data) {
      this.mapObj.center = toLonLat(data.geometry.flatCoordinates)

      if(data.type == 'marker') {
        this.openOverlayWindow(data);
      }else if(data.type == 'cluster') {
        this.clusterZoom(data.geometry.flatCoordinates);
      }else{
        this.selectedMarker = null;
      }
    },

    clusterZoom(data){
      const view = this.$refs.view
      const newZoom = view.getZoom() + 1.25
      this.mapObj.zoom = newZoom
      view.setZoom(newZoom)
      //view.setCenter(data);
    },

    openOverlayWindow(data){

      this.selectedMarker = {
        id: data.id,
        title: data.title,
        position: data.geometry.flatCoordinates,
      };
      if(typeof data.data != "undefined") {
        //console.log('openOverlayWindow', data.data);
        this.selectedMarker.data = data.data;
      }

      const view = this.$refs.view

      //view.setZoom(view.getZoom() + 1.5)
      view.setCenter(data.geometry.flatCoordinates);
    },

    handlePointerMove(event) {
      //console.log('dev handlePointerMove', event);
      this.olMap = this.$refs.mapObj.map
      if (!this.olMap) return;

      // Zjištění, zda se ukazatel nachází nad nějakým feature
      const pixel = this.olMap.getEventPixel(event.originalEvent);
      const hit = this.olMap.hasFeatureAtPixel(pixel);

      const hoveredFeature = hit ?
          this.olMap.forEachFeatureAtPixel(pixel, feature => feature) :
          null;

      // Kontrola, zda je feature marker (podle ID)

      let isMarker = false
      if(hoveredFeature) {
        const fProperties = hoveredFeature.getProperties()
        if(typeof fProperties.type != "undefined") {
          isMarker = true;
        }
      }

      if(isMarker) {
        this.$refs.mapWrrapper.style.cursor = "pointer";
      }else{
        this.$refs.mapWrrapper.style.cursor = "unset";
      }
    },

    openModalCreateNewVenue() {
      console.log('dev openModalCreateNewVenue')
      this.modalOpen.config.display = true;
      this.modalOpen.title = 'Vytvor nove Misto';

      this.modalOpen.router = {
        "modul": "venue",
        "action": "new"
      }

      this.modalOpen.prefill ={
        general: {
          inputs: {}
        }
      }
/*
      if(item.meta.modal.prefill) {
        this.modalOpen.prefill = item.meta.modal.prefill;
      }else{
        this.modalOpen.prefill ={
          general: {
            inputs: {}
          }
        }
      }
      */
    },
  },
  watch: {
    "formObj.general.inputs.venue_id.val": {
      handler(newVal, oldVal) {
        //console.log('watch formObj.general.inputs.venue_id.val', newVal);
        if(
            newVal
        ){
          //this.venueId
          //console.log('watch formObj.general.inputs.venue_id.val CALL', newVal);
          this.getVenueDetail(newVal)
        }else{

        }

      },
      deep: true,
      immediate: true
    },


    "modalOpen.data": {
      handler(newVal) {
        if(newVal){

          if(newVal.id){
            //console.log('watch formObj.general.inputs.venue_id.val CALL2', newVal);
            this.getVenueDetail(newVal.id);
            this.formObj.general.inputs.venue_id.val = newVal.id;
            //nastav center
            this.modalOpen.data.submit = true;
            this.modalOpen.data.saved = true;
            this.modalOpen.config.display = false;
          }

        }
      },
      deep: true,
      immediate: true
    },

    inputObj: {
      handler() {
        this.inputModel = this.inputObj.val;
      },
      deep: true,
      immediate: true
    },
/*


    inputModel: {
      handler(newVal, oldVal) {
        if(newVal && newVal.id) {
          console.log('watch inputModel', newVal)
          this.callbackInputModel(newVal);
          this.$emit('update:modelValue', newVal.id )
        }else{
          this.$emit('update:modelValue', null )
        }
      },
      deep: true,
      immediate: true
    },
*/
  },
};
</script>
<style lang="scss" scoped>

.mapa {
  width: 100%;
  height: 400px;
  border: 1px dashed red;
}

.map-container {
  width: 100%;
  height: 600px;
}

.info-box {
  background: white;
  padding: .7rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  min-width: 100px;
  max-width: 33vw;

  &[data-zoom][data-zoom="15"] {
    background-color: red;
  }
  &[data-zoom][data-zoom="10"] {
    background-color: navy;
  }

}
/*
.info-box button {
  margin-top: 10px;
  padding: 5px 10px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.info-box button:hover {
  background: #0056b3;
}
*/
</style>
